import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import Axios from "../../../../config/axios";
import { DeleteSessionDiv, DeleteText, BackAndDeleteDiv, BackButton, DeleteButton } from "./styles";

const DeleteSession = ({
  setIsShowingDeleteSession,
  software,
  sessionId,
  toggleRechargeReports,
  setToggleRechargeReports,
  setIsLoadingReports,
}) => {
  const [t] = useTranslation("global");

  const handleSetShowDeleteSession = (e) => {
    e.preventDefault();
    setIsShowingDeleteSession(false);
  };
  const handleDeleteSession = (e) => {
    e.preventDefault();
    setIsShowingDeleteSession(false);
    Axios("put", `${WEB_SERVICE_MIMS}/sessions/delete/${software}/${sessionId}`)
      .then(({ data }) => {
        if (data.deletedSession) {
          setIsLoadingReports(true);
          setToggleRechargeReports(!toggleRechargeReports);
          toast.success(t("reports_deleteSession_deletedSessionMessage"));
        } else {
          toast.error(t("sendDataErrorMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("url error: ", error);
      });
  };

  return (
    <DeleteSessionDiv>
      <DeleteText>{t("reports_deleteSession_deleteSessionText")}</DeleteText>
      <BackAndDeleteDiv>
        <BackButton onClick={handleSetShowDeleteSession}>{t("back")}</BackButton>
        <DeleteButton onClick={handleDeleteSession}>{t("delete")}</DeleteButton>
      </BackAndDeleteDiv>
    </DeleteSessionDiv>
  );
};

export default DeleteSession;
